<form [formGroup]="accountSetupForm" (ngSubmit)="submitHandler()">
  <div *ngIf="skipStep1 === undefined" class="mb-10">
    <app-shared-loading text="Loading account..."></app-shared-loading>
  </div>

  <ng-container *ngIf="skipStep1 !== undefined">
    <ng-container *ngIf="step === 1">
      <div class="step-badge">Step 1 of 3</div>
      <h3 class="step-title">
        Thanks for confirming your phone and email! Let's setup your account.
      </h3>
    </ng-container>
    <ng-container *ngIf="step === 2">
      <div class="step-badge">Step 2 of 3</div>
      <h3 class="step-title">Where do you buy?</h3>
      <p class="step-subtitle step2">
        ZIP codes work best, but counties or CBSAs are fine too. Start typing to
        search and select as many as you like.
      </p>
    </ng-container>
    <ng-container *ngIf="step === 3">
      <h3 class="step-title">Last step!</h3>
      <p class="step-subtitle">
        We use this information to find you the best deals that match your
        strategy and provide the highest returns.
      </p>
    </ng-container>

    <ng-container *ngIf="step === 1 && !skipStep1">
      <app-account-setup-modal-form-investor2
        (nextStep)="goToStep(2)"
        (selectedChange)="handleEntities($event)"
        [error]="
          viewReady &&
          (accountSetupForm.get('entities')?.value?.length || 0) === 0
        "
      ></app-account-setup-modal-form-investor2>
    </ng-container>

    <ng-container *ngIf="step === 2">
      <app-account-setup-markets
        [disabled]="loading"
        [defaultSelected]="accountSetupForm.get('cbsaPreferences')?.value"
        (selectedChange)="handleCbsaPreferences($event)"
        [error]="
          viewReady &&
          (accountSetupForm.get('cbsaPreferences')?.value?.length || 0) === 0
        "
      ></app-account-setup-markets>
    </ng-container>

    <ng-container *ngIf="step === 3">
      <p class="text-xs mb-1">
        What best describes your real estate role(s)? Select all that apply.
      </p>
      <app-shared-multi-selector
        name="roles"
        label="Real Estate roles"
        requiredLabel="*"
        [focused]="false"
        [disabled]="loading"
        [options]="options['roles']"
        [selected]="[]"
        (handleChange)="handleRoles($event)"
        [errors]="accountSetupForm.get('roles')?.errors"
        [touched]="accountSetupForm.get('roles')?.touched"
      ></app-shared-multi-selector>

      <p class="text-xs mb-1">
        What's your investment strategy. Select all that apply.
      </p>
      <app-shared-multi-selector
        name="investmentStyles"
        label="My investment strategy"
        optionalLabel="(optional)"
        [disabled]="loading"
        [options]="options['investmentStyles']"
        [selected]="[]"
        (handleChange)="handleInvestmentStyles($event)"
        [errors]="accountSetupForm.get('investmentStyles')?.errors"
        [touched]="accountSetupForm.get('investmentStyles')?.touched"
      ></app-shared-multi-selector>

      <p class="text-xs mb-1">
        How much rehab work do you like to take on? Select all that apply.
      </p>
      <app-shared-multi-selector
        name="rehabComfortabilities"
        label="My rehab preferences"
        optionalLabel="(optional)"
        [disabled]="loading"
        [options]="options['rehabComfortabilities']"
        [selected]="[]"
        (handleChange)="handleRehabComfortabilities($event)"
        [errors]="accountSetupForm.get('rehabComfortabilities')?.errors"
        [touched]="accountSetupForm.get('rehabComfortabilities')?.touched"
      ></app-shared-multi-selector>
    </ng-container>

    <div *ngIf="step === 1" class="mt-3">
      <app-shared-button
        [loading]="loading"
        [disabled]="
          loading ||
          (viewReady &&
            (accountSetupForm.get('entities')?.value?.length || 0) === 0)
        "
        (click)="goToStep(2)"
        >Next</app-shared-button
      >
    </div>

    <div *ngIf="step === 2" class="flex gap-4 items-center mt-3">
      <div class="flex-1" *ngIf="!skipStep1">
        <app-shared-button
          [loading]="loading"
          (click)="goToStep(1)"
          theme="outline"
        >
          Go back
        </app-shared-button>
      </div>

      <div class="flex-1">
        <app-shared-button
          [loading]="loading"
          [disabled]="
            loading ||
            (viewReady &&
              (accountSetupForm.get('cbsaPreferences')?.value?.length || 0) ===
                0)
          "
          (click)="goToStep(3)"
          >Next</app-shared-button
        >
      </div>
    </div>

    <div *ngIf="step === 3" class="flex gap-4 items-center">
      <div class="flex-1">
        <app-shared-button
          [loading]="loading"
          (click)="goToStep(2)"
          theme="outline"
        >
          Go back
        </app-shared-button>
      </div>

      <div class="flex-1">
        <app-shared-button
          [loading]="loading"
          [disabled]="
            loading ||
            (viewReady &&
              (accountSetupForm.get('entities')?.value?.length || 0) === 0)
          "
          >Complete</app-shared-button
        >
      </div>
    </div>
  </ng-container>

  <div class="mt-7 text-sm text-center">
    You're logged in as {{ userFirstName }}. Not you?
    <a href="/logout">Log out</a>.
  </div>
</form>
